"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const FormBottomNavBar_1 = __importDefault(require("@Components/CreateWorkBottomNavs/FormBottomNavBar"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const common_1 = require("@Const/common");
const WizardStepIndicators_1 = __importDefault(require("@Components/WizardFlow/WizardStepIndicators"));
const EditWorkLayout = () => {
    const { rightsholderStore, workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const params = (0, react_router_dom_1.useParams)();
    const location = (0, react_router_dom_1.useLocation)();
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const [backLink, setBackLink] = (0, react_1.useState)();
    const [nextLink, setNextLink] = (0, react_1.useState)();
    const setLinksToBar = (stepNumber) => {
        switch (stepNumber) {
            case 0:
                setBackLink('');
                setNextLink('/edit/submission');
                break;
            case 1:
                setBackLink('/edit');
                setNextLink('/edit');
                break;
            case 2:
                setBackLink('/edit');
                setNextLink('/edit');
                break;
            case 3:
                setBackLink('/edit');
                setNextLink('/edit');
                break;
            case 4:
                setBackLink('/edit');
                setNextLink('/edit');
                break;
            case 5:
                setBackLink('');
                setNextLink('');
                break;
            default:
                break;
        }
    };
    const getCurrentStep = () => {
        const currentStepUrl = location.pathname.split('/').pop();
        switch (currentStepUrl) {
            case 'edit':
                return 0;
            case 'work-details':
                return 1;
            case 'writers':
                return 2;
            case 'publishers':
                return 3;
            case 'recordings':
                return 4;
            case 'submission':
                return 5;
            default:
                return 0;
        }
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('edit_work');
        const stepNumber = getCurrentStep();
        setCurrentStep(stepNumber);
        setLinksToBar(stepNumber);
    }, [location]);
    const typeWork = params.typeWork || 'bulk';
    const workID = params.workId;
    const currentRightsHolderId = rightsholderStore.currentRightsholderId;
    const coreLink = typeWork === 'bulk'
        ? `/member/${currentRightsHolderId}/create-work/bulk`
        : `/member/${currentRightsHolderId}/catalog/${typeWork}/${workID}`;
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: navigation_1.default.rightholder.catalog.root(currentRightsHolderId) });
    }
    const EditWorkHeader = () => {
        const steps = [
            { stepIndicator: { label: 'Enter Work Details', icon: common_1.ICONS.workDetails } },
            { stepIndicator: { label: 'Add Writers', icon: common_1.ICONS.writers } },
            { stepIndicator: { label: 'Add Publishers & Shares', icon: common_1.ICONS.publishers } },
            { stepIndicator: { label: 'Add Recording', icon: common_1.ICONS.recordings } },
            { stepIndicator: { label: 'Review', icon: common_1.ICONS.review } },
        ];
        return (react_1.default.createElement("div", { className: "head-create-work-wizard" },
            react_1.default.createElement("h1", null, "Catalog"),
            react_1.default.createElement(WizardStepIndicators_1.default, { currentIndex: currentStep - 1, steps: steps })));
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_helmet_1.default, { title: "Edit work" }),
        react_1.default.createElement("main", { className: "edit-work-scene" },
            react_1.default.createElement("div", { className: "steps-wrapper" },
                currentStep !== 0 && currentStep !== 5 && react_1.default.createElement(EditWorkHeader, null),
                react_1.default.createElement(react_router_dom_1.Outlet, null),
                !(typeWork === 'bulk' && currentStep === 0) && (react_1.default.createElement(FormBottomNavBar_1.default, { nextLink: `${coreLink}${nextLink}`, backLink: `${coreLink}${backLink}`, typeWork: typeWork, hideBackLink: !!backLink, isFormStep: currentStep === 0, isSubmittedStep: currentStep === 5, isFinishEntityStep: nextLink === '/form' }))))));
};
exports.default = EditWorkLayout;
